import React, { useContext, useEffect } from 'react';

import * as R from 'ramda';
import { Box } from '@mui/material';
import DispatchingDashboard from 'feature/dispatching/dashboard/DashBoard';
import TrailerStatus from 'feature/dispatching/compliance/trailer-status/TrailerStatus';
import DriverStatus from 'feature/dispatching/compliance/driver-status/DriverStatus';
import Loads from 'feature/dispatching/loads/Loads';
import LoadsPlan from 'feature/dispatching/loads-plan/LoadsPlan';
import ErrorScreen from 'feature/dispatching/ErrorScreen';
import { Route, Routes } from 'react-router-dom';
import { AuthContext } from 'authentication/AuthContext';
import { useGetAffiliateOptions, useRedirectAffiliateForRole } from 'hooks';
import { userRoles } from 'utils/currentUserRoles';
import { useDispatch } from 'react-redux';
import { EvaluateFlag } from 'common/FeatureFlags/Flag';
import dispatchingApi, { tagTypes, usePrefetch } from './dispatchingApi';

const Dispatching = () => {
  const { affiliates, currentAffiliate, userProfile } = useContext(AuthContext);
  const dispatch = useDispatch();

  const adminRole = process.env.REACT_APP_ADMIN;
  const hasCarrier = R.any(R.prop('carrier'), affiliates);
  const isAdmin = R.any(R.equals(adminRole), userProfile.groups);

  const prefetchTrailerLocations = usePrefetch('viewTrailerSummaryByLocation');
  const prefetchDriverLocations = usePrefetch('viewDriverSummaryByLocation');
  const prefetchLoadLocations = usePrefetch('viewLoadsSummaryByLocation');

  useRedirectAffiliateForRole(useGetAffiliateOptions([userRoles.CARRIER]), () => {
    dispatch(dispatchingApi.util.invalidateTags(tagTypes));
  });

  useEffect(() => {
    if (currentAffiliate) {
      prefetchTrailerLocations();
      prefetchDriverLocations();
      prefetchLoadLocations();
    }
  }, [prefetchDriverLocations, prefetchLoadLocations, prefetchTrailerLocations, currentAffiliate]);

  if (currentAffiliate && hasCarrier)
    return (
      <Box component="main" sx={{ mb: 0, ml: 0, mr: 2, mt: 6 }}>
        <Routes>
          <Route element={<DispatchingDashboard />} index />
          {EvaluateFlag(process.env.REACT_APP_LD_DISPATCHING_LOADS) && (
            <>
              <Route element={<Loads />} path="loads" />
              <Route element={<Loads />} path="loads/:viewBy" />
              <Route element={<Loads />} path="loads/:viewBy/:viewById" />
            </>
          )}
          {EvaluateFlag(process.env.REACT_APP_LD_V2) && (
            <>
              <Route element={<LoadsPlan />} path="loads-plan" />
              <Route element={<LoadsPlan />} path="loads-plan/:viewBy" />
              <Route element={<LoadsPlan />} path="loads-plan/:viewBy/:viewById" />
            </>
          )}
          <Route element={<TrailerStatus />} path="compliance/trailer-status" />
          <Route element={<TrailerStatus />} path="compliance/trailer-status/:viewBy" />
          <Route element={<TrailerStatus />} path="compliance/trailer-status/:viewBy/:viewById" />
          <Route element={<DriverStatus />} path="compliance/driver-status" />
          <Route element={<DriverStatus />} path="compliance/driver-status/:viewBy" />
          <Route element={<DriverStatus />} path="compliance/driver-status/:viewBy/:viewById" />
        </Routes>
      </Box>
    );

  // has no carrier affiliate
  if (currentAffiliate) return <ErrorScreen isAdmin={isAdmin} />;

  return null;
};

export default Dispatching;
